import { Link, useLocation } from 'react-router-dom';

/** Честная заглушка раздела: без фейковых кнопок; причина — отсутствие витрины. */
export function StubPage({ title, phase }: { title: string; phase?: string }) {
  const location = useLocation();
  return (
    <div className="stub">
      <h1 className="t-page-title">{title}</h1>
      <p className="t-secondary stub__phase">
        Раздел появится после подключения витрины данных{phase ? ` (${phase})` : ''}.
      </p>
      <p className="t-micro" style={{ marginTop: 'var(--sp-6)' }}>
        Маршрут: <span className="t-code tabular-nums">{location.pathname}</span>
      </p>
    </div>
  );
}

/** 404: маршрута нет — ссылка в рабочее место. */
export function NotFoundPage() {
  const location = useLocation();
  return (
    <div className="stub">
      <h1 className="t-page-title">Маршрут не найден</h1>
      <p className="t-secondary stub__phase">
        Страницы <span className="t-code">{location.pathname}</span> не существует. Проверьте ссылку или вернитесь к заказам.
      </p>
      <p style={{ marginTop: 'var(--sp-4)' }}>
        <Link className="btn btn--secondary" to="/orders">
          К заказам
        </Link>
      </p>
    </div>
  );
}
